/**
 * The list of plans available in this product.
 */
export enum PlanTypes {
  FREE = 'free',
  PERSONAL = 'personal',
  BUSINESS = 'business',
  ENTERPRISE = 'enterprise',
}
